import React, {ReactNode} from 'react'
import classnames from 'classnames'

import styles from './styles.module.css'

export type TSlotCardProps = {
  children: ReactNode | ReactNode[]
  className?: string
}

export function SlotCard({children, className}: TSlotCardProps) {
  return <div className={classnames(styles.root, className)}>{children}</div>
}
